//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import areaList from "../../assets/js/Area.js";

export default {
    name: "profileEdit",
    data() {
        return {
            date: '',
            show: false,
            areaList, //引用地区信息
            showArea: false,
            codeing: false,
            valueArea: '', //地区值
            arrArea: [], //存放地区数组
            memberProfile: {},
            content: '获取验证码',
            canClick: true,
            totalTime: 30,
            saving: false,
            member: {},
            minDate: new Date(1980, 0, 1),
            maxDate: new Date(),
            currentDate: new Date()
        }
    },
    methods: {
        bindShow() {
            this.showArea = true;
        },
        bindCancel() {
            this.showArea = false;
        },
        //地区选择
        onAreaConfirm(val) {
            console.log(val)
            if (val.length < 3) {
                return
            }
            this.showArea = false;
            this.arrArea = val;
            var addrInfo = val[0].name + '-' + val[1].name + '-' + val[2].name;
            this.valueArea = addrInfo;

            this.memberProfile.cityName = val[1].name;
            this.memberProfile.areaId = val[2].code;
            var arr = [];
            var nArr = []
            arr.push(val[0].code);
            arr.push(val[1].code);
            arr.push(val[2].code);
            this.memberProfile.areaCode = JSON.stringify(arr);
            nArr.push(val[0].name);
            nArr.push(val[1].name);
            nArr.push(val[2].name);
            this.memberProfile.areaName = JSON.stringify(nArr);

        },
        countDown() {
            if (!this.canClick) return;
            this.canClick = false;
            this.content = this.totalTime + 's后重新发送';
            let clock = window.setInterval(() => {
                this.totalTime--;
                this.content = this.totalTime + 's后重新发送';
                if (this.totalTime < 0) {
                    window.clearInterval(clock);
                    this.content = '重新发送验证码';
                    this.totalTime = 30;
                    this.canClick = true;
                }
            }, 1000)
        },
        getVerificationCode() {
            if (!/^1[35789]\d{9}$/.test(this.memberProfile.phoneNumber)) {
                this.$toast('手机号格式无效');
                return;
            }

            let params = {
                address: this.memberProfile.phoneNumber
            };
            this.codeing = true;
            abp.ajax.post('/api/services/app/Verification/SendVerificationCode', params).then(res => {
                this.$toast.success('发送成功');
                this.countDown();
            }).finally(() => {
                this.codeing = false;
            })
        },
        formatDate(date) {
            // this.memberProfile.birthday = date;
            return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
        },
        onConfirm(date) {
            this.show = false;
            this.date = this.formatDate(date);
            this.memberProfile.birthday = this.formatDate(date);
            // console.log(this.date);
        },
        onSave() {
            console.log(this.memberProfile);
            if (!this.memberProfile.name) {
                this.$toast('请输入用户名');
                return;
            }
            if (!/^1[35789]\d{9}$/.test(this.memberProfile.phoneNumber)) {
                this.$toast('手机号格式无效');
                return;
            }
            if (!/^\d{6}$/.test(this.memberProfile.code)) {
                this.$toast('请输入6位数字验证码');
                return;
            }
            // return;
            this.saving = false;
            abp.ajax.post('/api/services/app/Member/SaveMemberProfile', this.memberProfile).then(() => {
                this.$toast.success("修改成功");
                this.$router.back();
            }).finally(() => {
                this.saving = false;
            })
        },
        async getMyMember() {
            var vm = this;
            await this.$store.dispatch({
                type: 'member/getMyMember'
            }).then(() => {
                vm.member = {};
                vm.member = vm.$store.state.member.memberInfo;
                // this.memberProfile.name = this.member.name;
                if (JSON.stringify(this.member) !== '{}' || this.member != null || this.member != undefined) {
                    this.memberProfile.name = this.member.name;
                    this.memberProfile.phoneNumber = this.member.phoneNumber;
                    this.memberProfile.areaCode = this.member.areaCode;
                    this.memberProfile.cityName = this.member.cityName;
                    this.memberProfile.areaName = this.member.areaName;
                    this.memberProfile.birthday = this.member.birthday;
                    this.currentDate = new Date(this.member.birthdayStr);

                    if (this.member.areaId) {
                        this.memberProfile.areaId = vm.member.areaId.toString();
                    } else {
                        this.memberProfile.areaId = ''
                    }
                    if (this.member.areaName) {
                        var arr = [];
                        arr = JSON.parse(vm.member.areaName);
                        for (var i = 0; i < arr.length; i++) {
                            this.valueArea = this.valueArea + arr[i];
                        }
                    }
                    this.date = this.member.birthdayStr
                    // this.valueArea = m.cityName;
                }
            });
        },

    },
    created() {
        this.getMyMember();


    }
}
